import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutColumn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="layout-column, grid, column" maskId="round-filled-radius-0-stroke-1.5-IconLayoutColumn"><path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H11.25V21L3.75 21C3.33579 21 3 20.6642 3 20.25V3.75Z" fill="currentColor"/><path d="M12.75 21L20.25 21C20.6642 21 21 20.6642 21 20.25V3.75C21 3.33579 20.6642 3 20.25 3H12.75V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutColumn;
